import {useEffect, useState} from "react";
import {UpsApi} from "../../../../services/Ups.api";
import {Input, InputGroup, toaster, Whisper} from "rsuite";
import UpdateButton from "../../../shared/UpdateButton/UpdateButton";
import GearIcon from "@rsuite/icons/Gear";
import StatusControl from "../../../shared/StatusControl/StatusControl";
import {useNavigate} from "react-router-dom";
import {getTooltip} from "../../../../shared/Tooltip";
import NotificationFactory from "../../../../shared/Notifications";

import {UpsParams, UpsSectionProps} from "../MainPage.model";

const UpsSection = ({ups, deviceId}: UpsSectionProps) => {
  const [loading, setLoading] = useState(false);
  const [upsParams, setUpsParams] = useState<UpsParams>({});
  const navigate = useNavigate();

  useEffect(() => {
    if (ups?.id !== null && ups?.id !== undefined) {
      getUpsParams().then();
    }
  }, [ups?.id]);

  const getUpsParams = async () => {
    setLoading(true);
    try {
      const result = await UpsApi.getUpsParams(String(ups?.id));
      setUpsParams(result);
    } catch (error) {
      toaster.push(
        NotificationFactory.error(),
        { placement: "topEnd" }
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="fieldset-wrapper">
      <div className="legend-title main-legend-title">ИБП {ups?.model}</div>
      <section className="primary-clock">
        <div className="row">
          <div className="col-md-12 text-end">
            <UpdateButton
              loading={loading}
              onRefresh={getUpsParams}
            />
          </div>
        </div>
        <div className="row align-items-center" style={{padding: '10px', paddingTop: '0px'}}>
          <div className="col-md-12 text-center d-flex align-items-center p-0">
            <StatusControl status={upsParams?.externalPowerEnabled ? "online" : "offline"}/>
            <p>Состояние выхода ИБП (включен/выключен)</p>
          </div>
          <div className="col-md-12 text-center d-flex align-items-center p-0">
            <StatusControl status={upsParams?.externalPowerEnabled ? "online" : "offline"}/>
            <p>Наличие внешней сети 220В (да/нет)</p>
          </div>
        </div>
        <div className="row" style={{padding: '10px', paddingTop: '0px'}}>
          <div className="col-md-12">
            <InputGroup className="mb-2">
              <InputGroup.Addon>Выходное напряжение</InputGroup.Addon>
              <Input
                size={"md"}
                value={upsParams?.outputVoltage}
              />
            </InputGroup>
            <InputGroup className="mb-2">
              <InputGroup.Addon>Выходной ток</InputGroup.Addon>
              <Input
                size={"md"}
                value={upsParams?.outputCurrent}
              />
            </InputGroup>
          </div>
          <div className="col-md-12">
            <InputGroup className="mb-2">
              <InputGroup.Addon>Напряжение на аккумуляторной батарее</InputGroup.Addon>
              <Input
                size={"md"}
                value={upsParams?.batteryVoltage}
              />
            </InputGroup>
            <InputGroup className="mb-2">
              <InputGroup.Addon>Ток заряда аккумулятора</InputGroup.Addon>
              <Input
                size={"md"}
                value={upsParams?.batteryChargeCurrent}
              />
            </InputGroup>
            <InputGroup className="mb-2">
              <InputGroup.Addon>Напряжение от сетевого блока питания</InputGroup.Addon>
              <Input
                size={"md"}
                value={upsParams?.powerSupplyVoltage}
              />
            </InputGroup>
          </div>
        </div>

        <div className="settings">
          <a
            className="settings-link"
            href="#"
            onClick={(e) => {
              navigate(`/devices/${String(deviceId)}?tab=devices&externalId=${ups?.id}`);
              e.preventDefault();
            }}
          >
            <Whisper
              placement="topStart"
              controlId="control-id-hover"
              trigger="hover"
              speaker={getTooltip('Перейти в настройки')}>
            <GearIcon className="gear-icon"></GearIcon>
            </Whisper>
          </a>
        </div>
      </section>
    </div>
  )
}

export default UpsSection;
